/* The salon on Google Maps.
   Pulled out of /contact so /hairdresser embeds the very same map rather than
   a second copy that can drift out of step. */

import React from 'react';

const EMBED_SRC = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2901.5239738396103!2d21.864649012905854!3d43.345149270997815!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4755b7d990158879%3A0xeec35ad54ebb4ce!2sVision%20Beauty!5e0!3m2!1ssr!2srs!4v1757082564052!5m2!1ssr!2srs';

const SalonMap = ({ title, height = 450, style }) => (
  <iframe
    title={title}
    src={EMBED_SRC}
    width="600"
    height={height}
    style={{ border: '0', ...style }}
    loading="lazy"
  />
);

export default SalonMap;
